import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OwnerBlockRequestTargetListPage" */
	'pages/intervention/TaskZoneBlockedListPage'));

export default [{ component, exact: true, path: '/blocked_task_zones' }];